import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { Box, themeUtils as tu } from '@zen-common/components-base';
import Search from '../Search';

/**
 * A layout with search on top and content in a disable-able wrapper
 *
 * @param {Object} props
 * @param {boolean} props.forceEditMode - force search to always stay in edit mode
 * @param {boolean} props.canDisable - can the content be disabled on edit mode
 */
export default function SearchOnTopLayout({ forceEditMode, canDisable = true, children }) {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const onStateChange = useCallback(({ isOpen }) => setIsSearchOpen(isOpen), []);

  return (
    <MainContainer>
      <SearchWrapper>
        <Search onStateChange={onStateChange} editOnly={forceEditMode} />
      </SearchWrapper>
      <DisableAbleWrapper disabled={canDisable ? isSearchOpen : false}>
        {children}
      </DisableAbleWrapper>
    </MainContainer>
  );
}

const MainContainer = styled(Box)`
  flex-grow: 1;
  flex-direction: column;
  width: 100%;
  ${tu.mq({
    display: ['block', null, null, 'flex'],
    height: ['auto', null, null, '100%'],
  })}
`;
const SearchWrapper = styled(Box)`
  border-bottom: 1px solid ${tu.color('borderDark')};
`;
const DisableAbleWrapper = styled(Box)`
  user-select: ${(p) => (p.disabled ? 'none' : 'auto')};
  pointer-events: ${(p) => (p.disabled ? 'none' : 'auto')};
  opacity: ${(p) => (p.disabled ? '0.2' : '1')};
  flex-grow: 1;
  ${tu.mq({
    display: ['block', null, null, 'flex'],
    height: ['auto', null, null, '100%'],
  })}
`;
